import { createTheme } from '@mui/material/styles';
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/700.css';
import { brand } from './brand';

const theme = createTheme({
  palette: {
    primary: {
      main: brand.primary,
      dark: brand.primaryDark,
      contrastText: brand.white,
    },
    secondary: {
      main: brand.textSecondary,
      contrastText: brand.white,
    },
    text: {
      primary: brand.text,
      secondary: brand.textSecondary,
    },
    background: {
      default: brand.surface,
      paper: brand.white,
    },
    divider: brand.border,
  },
  typography: {
    fontFamily: '"DM Sans", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '28px',
      lineHeight: 'normal',
      color: brand.text,
    },
    h2: {
      fontWeight: 700,
      fontSize: '28px',
      lineHeight: 'normal',
    },
    h3: {
      fontWeight: 600,
      fontSize: '22px',
      lineHeight: 'normal',
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '16px',
      color: brand.textSecondary,
    },
    body1: {
      fontWeight: 400,
      fontSize: '15px',
      lineHeight: '24px',
      color: brand.text,
    },
    body2: {
      fontSize: '14px',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: brand.surface,
        },
        '::-webkit-scrollbar-track': {
          backgroundColor: brand.surface,
        },
        '::-webkit-scrollbar': {
          width: '10px',
          background: brand.surface,
        },
        '::-webkit-scrollbar-thumb': {
          background: '#C9D3E6',
          borderRadius: '10px',
        },
        '.MuiContainer-root': {
          minHeight: '700px',
        },
        '.MuiPaper-root .MuiContainer-root': {
          minHeight: 'auto',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        // O MUI clareia o `divider` em 88% para a borda das células; como o
        // divider da marca já é claro, a linha sumia. Fixa a cor da borda.
        root: {
          borderBottom: `1px solid ${brand.border}`,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: brand.border,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#C9D3E6',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: brand.primary,
            boxShadow: 'none',
          },
        },
      },
    },
  },
});

export default theme;
